import { createIcon } from '../create-icon'

// Flat trend line — steady, reliable performance
export const GpiConsistency = createIcon('GpiConsistency', ({ strokeWidth }) => (
  <>
    <path d="M3 3v16a2 2 0 0 0 2 2h16" strokeWidth={strokeWidth} />
    <path d="M7 16l4-4 4 2 6-8" strokeWidth={strokeWidth} />
  </>
))
